import { useRef, useState, useEffect } from "react";
import "./Hero.css";
import { Controller, Scene } from "react-scrollmagic";
import {
  Animator,
  ScrollContainer,
  ScrollPage,
  batch,
  Fade,
  FadeIn,
  FadeOut,
  Move,
  MoveIn,
  MoveOut,
  Sticky,
  StickyIn,
  StickyOut,
  Zoom,
  ZoomIn,
  ZoomOut,
} from "react-scroll-motion";
// import styled from "styled-components";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { CSSPlugin } from "gsap/CSSPlugin";
gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(CSSPlugin);

const Hero = () => {
  const [scrollPosition, setScrollPosition] = useState(0);
  const [pageHeight, setPageHeight] = useState(0);
  const [scrollPercentage, setScrollPercentage] = useState(0);

  const handleScroll = () => {
    const position = window.pageYOffset;
    const pageHeight = window.outerHeight;
    setScrollPosition(position);
    setPageHeight(pageHeight);
    console.log(position);
    console.log(pageHeight);
  };

  // const imgRef = useRef();
  // const yPos = 0 - window.pageYOffset / 5;

  const scrollpr = () => {
    setScrollPercentage(scrollPosition / 100 + "%");
  };

  // const parallax = () => {
  //   const yPos = 0 - window.pageYOffset / 4;

  //   imgRef.style.marginTop = 50 + yPos + "%";
  // };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    window.addEventListener("scroll", scrollpr());

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  });

  // const heroText = useRef(null);

  // useEffect(() => {
  //   const text = heroText.current;
  //   const tl = gsap.timeline({
  //     scrollTrigger: {
  //       trigger: "text",
  //     },
  //   });
  //   tl.to(text, {
  //     duration: 12,
  //     markers: true,
  //     pin: true,
  //   });
  // });

  const Scale = () => ({
    in: {
      style: {
        transform: () => `scale(0.4)`,
        transition: "scale 10s ease",
      },
    },
    // out: {
    //   style: {
    //     transform: (p) => `rotate(${p * 360 * cycle}deg)`,
    //   },
    // },
  });

  const imgRef = useRef(null);
  const Text = useRef(null);
  const sectionH = useRef(null);
  const fixedText = useRef(null);

  useEffect(() => {
    const image = imgRef.current;
    const text = Text.current;
    const height = sectionH.current;
    const fixed = fixedText.current;

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: image,

        start: "center center",
        end: "300px top",
        toggleActions: "restart pause reverse pause",
        scrub: 2.1,

        pin: true,
        // pinType: "",
        // anticipatePin: 1,
      },
    });

    tl.fromTo(
      image,
      { scale: 0.4 },
      {
        scale: 1,
      }
    );
    // tl.fromTo(
    //   image,
    //   {
    //     width: "20%",
    //   },
    //   { width: "100%" }
    // );

    tl.fromTo(text, { opacity: 0 }, { opacity: 1 });
    // tl.fromTo(fixed, { display: "block" }, { display: "none" });
  }, []);

  const ZoomInScrollOut = batch(StickyIn(), FadeIn(), ZoomIn());

  return (
    // <div className="about-hero">
    //   <div className="about-hero-mainText" style={{ position: "fixed" }}>
    //     Get paid the easy way
    //   </div>
    //   <div className="about-hero-container">
    //     <div className="about-hero-showcase">
    //       <img
    //         src="/assets/aboutImg.svg"
    //         alt=""
    //         ref={imgRef}
    //         style={{
    //           marginTop: 100 + yPos + "%",

    //           // width: scrollPercentage,

    //           // scale: scrollPosition,

    //           width:
    //             scrollPosition >= (34 / 100) * pageHeight
    //               ? scrollPosition / 2 + "%"
    //               : "448px",

    //           // height: width >= "100%" ? "648px" : "420px",
    //           // position:
    //           //   scrollPosition > 0.2 * pageHeight ? "fixed" : "static",
    //         }}
    //       />
    //     </div>
    //   </div>
    // </div>

    <div className="about-hero">
      <div className="about-hero-container">
        {/* <Controller>
          <Scene duration={1000} offset={0} pin>
            <div className="about-hero-mainText" ref={heroText}>
              <h2>Get Paid the easy way</h2>
            </div>
          </Scene>
        </Controller> */}

        {/* <div className="about-hero-mainText" ref={heroText}>
          <h2>Get Paid the easy way </h2>
        </div> */}
        {/* IMPORTANTTTTT */}
        {/* <ScrollContainer>
          <ScrollPage page={0}>
            <Animator animation={batch(Sticky())}>
              <div className="about-hero-mainText">
                <h2>Get Paid the easy way </h2>
              </div>
            </Animator>
          </ScrollPage>
        </ScrollContainer> */}

        {/* IMPORTANT */}

        {/* <div>
          <div className="section">
            <div id="trigger">
              <Controller>
                <Scene
                  // duration={500}
                  classToggle="zap"
                  triggerElement="#trigger"
                  indicators={true}
                >
                  {(progress, event) => (
                    <img className="test" src="assets/aboutImg.svg" alt="" />
                  )}
                </Scene>
              </Controller>
            </div>
          </div>
        </div> */}
        <div className="section" ref={sectionH}>
          <div
            className="fixed-text"
            ref={fixedText}
            style={{ display: scrollPosition > 750 ? "none" : "block" }}
          >
            Get paid the easy way
          </div>
        </div>

        <div className="showcase-container">
          <div className="imageContainer" ref={imgRef}>
            {/* <img src="/assets/aboutImg.svg" alt=""  /> */}
            <div className="aboutText" ref={Text}>
              <div className="topAbout">
                We broaden the scope by allowing all types of businesses with
                different levels of customer sophistication receive payments
                easily. Customers who do not have cash, card, or even
                smartphones can easily pay with USSD and it’d be verified
                instantly with Qevolt.
              </div>
              <div className="bottomAbout">
                We give businesses the platform to acquire new customers,
                satisfy existing ones, and increase sales beyond expectations.
                But it doesn’t end here. As our product evolves, we’d keep
                bringing in peculiar solutions to your business needs
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;

// const ClassToggleStyled = styled.div`
//   .section {
//     height: 100vh;
//   }

//   .test {
//     transition: width 0.3s ease;
//     width: 100px;
//     height: 100px;
//     background-color: red;
//     margin: 0 !important;
//   }

//   &.yellow {
//     background-color: yellow;
//   }

//   .zap {
//     width: 100%;
//   }
// `;
